import React, { useState } from "react";
import { Button, Input, Select } from "antd";
import SuccessIcon from "../components/BrandsPartnerComponents/DeleteIcon";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import SuccessComponent from "../components/BrandsPartnerComponents/SuccessComponent";

const { Option } = Select;

const SuccessPartnerPage: React.FC = () => {
  function openMail(): void {
    window.location.href = "mailto:";
  }

  return (
    <SuccessComponent
      title="Thank you for sharing your story with us!"
      message={
        <span>
          {" "}
          Instructions: 
          <ol type="1" className=" list-decimal leading-tight mt-2">
         <li className="mb-2 ml-4">Please open your registered email and look for an invitation email
          from us. If you do not find it in your inbox, kindly check
          your spam folder. </li><li className="mb-2 ml-4">Once located, click on the provided link to verify
          your account and set up your password.</li>
          </ol>
        </span>
      }
    />
  );
};

export default SuccessPartnerPage;
